export const getProductOptions = `
  query getProductOptions {
    products {
      value: id
      label: name
    }
  }
`;

export const getDealStatusOptions = `
  query getDealStatusOptions {
    dealStatuses {
      value: id
      label: name
    }
  }
`;
